import { FC } from "react";
import styled from "@emotion/styled";
import { SettingsSubsectionWrapper } from "@/pages/settings/components/setting-subsection-wrapper";
import { SettingsSectionWrapper } from "@/pages/settings/components/settings-section-wrapper";
import { NotificationPreference } from "@/store/pages/SettingsEmailPreferencesPageStore/types";
import { observer } from "mobx-react-lite";
import { useAppStore } from "@/store";
import { MDSText, MDSTextVariant, MDSToggle } from "@/mds";

const emailNotificationPreferenceLabels: { [key in NotificationPreference]: string } = {
  EMAIL_WEEKLY_NEWSLETTER: "Weekly tips and updates from Mem",
  EMAIL_USER_SHARE: "Mems shared with me",
};

export const SettingsEmailPreferencesPage: FC = observer(() => {
  const { pageStore } = useAppStore();
  const page = pageStore.settingsEmailPreferencesPage;
  const accountNotificationPreferencesData = page.accountNotificationPreferencesData.data;

  const toggleEmailNotificationPreference = async (key: NotificationPreference) => {
    if (!accountNotificationPreferencesData) return;
    const isEnabled = accountNotificationPreferencesData[key];
    await page.updateNotificationPreference(key, !isEnabled);
  };

  return (
    <SettingsSectionWrapper>
      <SettingsSubsectionWrapper title="Email preferences">
        {Object.entries(emailNotificationPreferenceLabels).map(([key, label]) => {
          const preference = key as NotificationPreference;
          return (
            <Selector key={key}>
              <MDSText variant={MDSTextVariant.ParagraphS}>{label}</MDSText>
              <MDSToggle
                checked={accountNotificationPreferencesData?.[preference]}
                onChange={() => toggleEmailNotificationPreference(preference)}
                disabled={!accountNotificationPreferencesData}
              />
            </Selector>
          );
        })}
      </SettingsSubsectionWrapper>
    </SettingsSectionWrapper>
  );
});

const Selector = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;
